module.exports = __webpack_public_path__ + "static/Ali-3e814107bc09c6e6ddeae3d6385425d0.png";